export default __webpack_public_path__ + "static/media/loader-mariposa.c0adf9b2.gif";